/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AuthorizationDto {
  site?: string;
  role?: AuthorizationDto.RoleEnum;
  projectId?: string;
}
export namespace AuthorizationDto {
  export const RoleEnum = {
    Foreman: 'FOREMAN',
    Operator: 'OPERATOR',
  } as const;
  export type RoleEnum = (typeof RoleEnum)[keyof typeof RoleEnum];
}
